export { default as Img200 } from './processed/200/Pixels.jpg';
export { default as Img400 } from './processed/400/Pixels.jpg';
export { default as Imgthumb } from './processed/thumb/Pixels.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Pixels.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Pixels.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      183,
      115,
      53
    ],
    "_population": 1762,
    "_hsl": [
      0.0794871794871795,
      0.5508474576271186,
      0.4627450980392157
    ]
  },
  "LightVibrant": {
    "_rgb": [
      246,
      231,
      112
    ],
    "_population": 1850,
    "_hsl": [
      0.1480099502487562,
      0.8815789473684212,
      0.7019607843137254
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      35,
      52,
      83
    ],
    "_population": 1516,
    "_hsl": [
      0.607638888888889,
      0.4067796610169491,
      0.23137254901960785
    ]
  },
  "Muted": {
    "_rgb": [
      163,
      114,
      87
    ],
    "_population": 1132,
    "_hsl": [
      0.05921052631578949,
      0.30399999999999994,
      0.49019607843137253
    ]
  },
  "LightMuted": {
    "_rgb": [
      161,
      172,
      207
    ],
    "_population": 10,
    "_hsl": [
      0.6268115942028986,
      0.323943661971831,
      0.7215686274509804
    ]
  },
  "DarkMuted": {
    "_rgb": [
      113,
      72,
      54
    ],
    "_population": 1512,
    "_hsl": [
      0.05084745762711865,
      0.35329341317365265,
      0.32745098039215687
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Pixels.js